import React from "react";
const header = () => {
    return (
        <>
        <div className="header-wrapper"></div>
            <div className="main-info">
                <h1>Hi, I am Deekshitha</h1>
                <p>I'm a Web Developer.</p>
            </div>
        </>
    );
}

export default header;
